import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Card, Row, Typography } from 'seagull';
import { ArrowRight } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './AppPromo.module.scss';
import { useAppPromoClick } from './hooks/useAppPromoClick';
export const GetAppPromoTID = (parentTestId)=>getTestIds(parentTestId);
export const AppPromo = ()=>{
    const { t: sidebarTexts } = useLocaleKeys('navigation.bar.sidebar');
    const { native } = useIoContext();
    const handleClick = useAppPromoClick();
    const { AppPromoTID } = useMemo(()=>GetAppPromoTID(), []);
    if (native.isNative) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Card, {
        as: "button",
        shadow: "none",
        className: styles.promoCard,
        testId: AppPromoTID.Root(),
        bi: {
            name: 'sidebar_mobile_app_promo'
        },
        onClick: handleClick,
        children: /*#__PURE__*/ _jsxs(Row, {
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "invertedStandard",
                    children: sidebarTexts.getMobileApp()
                }),
                /*#__PURE__*/ _jsx(Box, {
                    as: "span",
                    className: styles.arrowBadge,
                    children: /*#__PURE__*/ _jsx(ArrowRight, {
                        size: 16
                    })
                })
            ]
        })
    });
};
